import React from "react";
import LiteYouTube from "@/components/LiteYouTube";

type Chapter = { time: string; title: string };

const OVERDUB_CHAPTERS: Chapter[] = [
  { time: "0:00", title: "Welcome to Overdub Studio" },
  { time: "0:43", title: "Uploading your song" },
  { time: "1:00", title: "Tagging your lyrics" },
  { time: "1:58", title: "Matching tags and line counts" },
  { time: "2:25", title: "Locking lyrics and checking sections" },
  { time: "3:25", title: "Choosing a generation strategy" },
  { time: "4:03", title: "When to use inpainting" },
  { time: "4:48", title: "Extension types explained" },
  { time: "5:56", title: "Manual extension" },
  { time: "6:42", title: "The experimental mixer" },
  { time: "7:08", title: "Scramble options: none, alt, single" },
  { time: "7:45", title: "Vocal layering and backing vocals" },
  { time: "8:52", title: "Changing lyrics for the backing layer" },
  { time: "9:52", title: "Listening back to the inpaint take" },
  { time: "10:56", title: "Queueing takes and marking keepers" },
  { time: "11:29", title: "Redetecting section times" },
  { time: "11:59", title: "About the 50% fail rate" },
  { time: "12:37", title: "What it struggles with: opera and musicals" },
  { time: "13:08", title: "Training a voice model" },
  { time: "13:48", title: "Downloading stems and comp lanes" },
];

function WalkthroughEmbed({
  embedId,
  iframeTitle,
  heading,
  subheading,
  chapters,
}: {
  embedId: string;
  iframeTitle: string;
  heading: string;
  subheading: string;
  chapters: Chapter[];
}) {
  return (
    <div>
      <h3 className="text-xl font-semibold text-base-content">{heading}</h3>
      <p className="text-sm text-base-content/70 mt-1 mb-3">{subheading}</p>
      <LiteYouTube videoId={embedId} title={iframeTitle} />

      <div className="collapse collapse-plus bg-base-200 mt-4">
        <input type="checkbox" className="peer" />
        <div className="collapse-title text-lg font-medium peer-checked:text-primary">
          Video chapters
        </div>
        <div className="collapse-content">
          <ul className="space-y-1 text-sm text-base-content/80">
            {chapters.map((chapter) => (
              <li key={chapter.time} className="flex gap-3">
                <span className="font-mono text-primary shrink-0 w-12">{chapter.time}</span>
                <span>{chapter.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default function V3WalkthroughVideo() {
  return (
    <div className="my-8 max-w-3xl mx-auto space-y-10">
      <WalkthroughEmbed
        embedId="TLMMHNrzn8s"
        iframeTitle="ChangeLyric Overdub Studio Walkthrough: Full Tutorial"
        heading="Overdub Studio walkthrough (14 min)"
        subheading="Our newest editor. Replaces the older Overdub and Horizon tools with one guided workspace for every kind of lyric swap, from tagging your lyrics to downloading stems."
        chapters={OVERDUB_CHAPTERS}
      />
    </div>
  );
}
